import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetContractualTermPending,
	GetContractualTermPendingParams,
} from 'domain/usecases/private/home/get-contractual-term-pending';

export class RemoteGetContractualTermPending implements GetContractualTermPending {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<boolean>,
	) {}

	async get({...restParams}: GetContractualTermPendingParams): Promise<boolean> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: restParams,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return false;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
